import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {CheckoutService} from '../services/checkout.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {environment} from "../../environments/environment";
import {CustomerService} from "../services/customer.service";
import {DocumentTypesEnum} from "../app.enum";
import {DialogErrorComponent} from "../dialog-error/dialog-error.component";
import {MatDialog} from "@angular/material";

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.styl']
})
export class CheckoutComponent implements OnInit {

  Math: Math = Math;
  now: Date = new Date();
  numParticipants = 1;
  purchase: any = {
    description: '',
    total_value: 0,
    shipping_price: 0
  };
  timer_date = null;
  checkout_form: FormGroup;
  document_types = [];
  customer = {
    document_number: '',
    name: '',
    main_img: ''
  };
  divide_payment = false;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private checkoutService: CheckoutService,
              private customerService: CustomerService,
              private _formBuilder: FormBuilder,
              public dialog: MatDialog) {
  }

  ngOnInit() {
    this.buildFormCheckout();
    this.getPurchaseData();
    this.document_types = environment.document_types;
    this.timer_date = setInterval(() => {
      this.now = new Date();
    }, 1000);
  }


  private documentTypeValidator(control: FormControl) {
    const document_type = control.value;
    if (document_type in DocumentTypesEnum) {
      return null;
    } else {
      return {
        documentType: 'Tipo de documento invalido'
      };
    }
  }

  buildFormCheckout() {
    this.checkout_form = this._formBuilder.group({
      email: ['owner_email' in this.route.snapshot.queryParams ? this.route.snapshot.queryParams['owner_email'] : '',
        [Validators.required, Validators.email]],
      first_name: ['owner_first_name' in this.route.snapshot.queryParams ? this.route.snapshot.queryParams['owner_first_name'] : '',
        [Validators.required]],
      last_name: ['owner_last_name' in this.route.snapshot.queryParams ? this.route.snapshot.queryParams['owner_last_name'] : '',
        [Validators.required]],
      cellphone: ['owner_cellphone' in this.route.snapshot.queryParams ?
        Number.parseInt(this.route.snapshot.queryParams['owner_cellphone']) : null,
        [Validators.required, Validators.minLength(7)]],
      parts: ['parts' in this.route.snapshot.queryParams ? Number.parseInt(this.route.snapshot.queryParams['parts']) : 2,
        [Validators.required, Validators.min(1)]],
      document_number: ['owner_document' in this.route.snapshot.queryParams ? this.route.snapshot.queryParams['owner_document'] : null,
        [Validators.required]],
      document_type: ['owner_document_type' in this.route.snapshot.queryParams ?
        Number.parseInt(this.route.snapshot.queryParams['owner_document_type']) : 1
        , [Validators.required, this.documentTypeValidator]],
    });

    if ('owner_email' in this.route.snapshot.queryParams && this.checkout_form.get('email').valid) {
      this.checkout_form.get('email').disable();
    }
    if ('owner_first_name' in this.route.snapshot.queryParams && this.checkout_form.get('first_name').valid) {
      this.checkout_form.get('first_name').disable();
    }
    if ('owner_last_name' in this.route.snapshot.queryParams && this.checkout_form.get('last_name').valid) {
      this.checkout_form.get('last_name').disable();
    }
    if ('owner_cellphone' in this.route.snapshot.queryParams && this.checkout_form.get('cellphone').valid) {
      this.checkout_form.get('cellphone').disable();
    }
    if ('owner_document' in this.route.snapshot.queryParams && this.checkout_form.get('document_number').valid) {
      this.checkout_form.get('document_number').disable();
    }
    if ('owner_document_type' in this.route.snapshot.queryParams && this.checkout_form.get('document_type').valid) {
      this.checkout_form.get('document_type').disable();
    }
  }

  getPurchaseData(): void {
    this.divide_payment = 'parts' in this.route.snapshot.queryParams ?
      Number.parseInt(this.route.snapshot.queryParams['parts']) > 1
      : true;
    this.purchase.description = this.route.snapshot.queryParamMap.get('description');
    this.purchase.total_value = Number.parseInt(this.route.snapshot.queryParamMap.get('total_value'));

    if ('shipping_price' in this.route.snapshot.queryParams) {
      this.purchase.shipping_price = Number.parseInt(this.route.snapshot.queryParamMap.get('shipping_price'));
      this.checkout_form.get('parts').setValidators([
        Validators.required,
        Validators.min(1),
        Validators.max(
          Math.floor(
            (
              Number.parseInt(this.route.snapshot.queryParamMap.get('total_value')) +
              Number.parseInt(this.route.snapshot.queryParamMap.get('shipping_price'))
            ) / 10000
          )
        )
      ]);
    } else {
      this.checkout_form.get('parts').setValidators([
        Validators.required,
        Validators.min(1),
        Validators.max(
          Math.floor(
            Number.parseInt(this.route.snapshot.queryParamMap.get('total_value')) / 10000
          )
        )
      ]);
    }
    this.customerService.checkApiKeyCustomer(
      this.route.snapshot.queryParamMap.get('api_key'),
      this.route.snapshot.queryParamMap.get('total_value'),
      this.route.snapshot.queryParamMap.get('description'),
      this.route.snapshot.queryParamMap.get('verify'),
      this.route.snapshot.queryParamMap.get('shipping_price'),
      this.route.snapshot.queryParamMap.get('minutes'),
      this.route.snapshot.queryParamMap.get('signature')).subscribe((data: any) => {
      this.customer = data.customer;
    });
  }

  createPurchase(method): void {
    this.purchase.suggested_participation = this.purchase.total_value / this.numParticipants;

    this.checkoutService.addPurchase({
      first_name: this.checkout_form.get('first_name').value,
      last_name: this.checkout_form.get('last_name').value,
      email: this.checkout_form.get('email').value,
      document_number: this.checkout_form.get('document_number').value,
      document_type: this.checkout_form.get('document_type').value,
      cellphone: this.checkout_form.get('cellphone').value,
      description: this.purchase.description,
      suggested_participation: this.Math.floor((this.purchase.total_value + this.purchase.shipping_price) /
        (this.divide_payment ? this.checkout_form.get('parts').value : 1)),
      total_value: Number.parseInt(this.purchase.total_value),
      api_key: this.route.snapshot.queryParamMap.get('api_key'),
      verify: this.route.snapshot.queryParamMap.get('verify'),
      signature: this.route.snapshot.queryParamMap.get('signature'),
      //  Shipping_info
      address: 'shipping_address' in this.route.snapshot.queryParams ?
        this.route.snapshot.queryParams['shipping_address'] : null,
      city: 'shipping_city' in this.route.snapshot.queryParams ?
        this.route.snapshot.queryParams['shipping_city'] : null,
      country: 'shipping_country' in this.route.snapshot.queryParams ?
        this.route.snapshot.queryParams['shipping_country'] : null,
      shipping_price: 'shipping_price' in this.route.snapshot.queryParams ?
        this.route.snapshot.queryParams['shipping_price'] : null,
      // Time Expiry Purchase
      minutes: 'minutes' in this.route.snapshot.queryParams ?
        this.route.snapshot.queryParams['minutes'] : null,
      // URLs Company
      response_url: 'response_url' in this.route.snapshot.queryParams ?
        this.route.snapshot.queryParams['response_url'] : null,
      confirmation_url: 'confirmation_url' in this.route.snapshot.queryParams ?
        this.route.snapshot.queryParams['confirmation_url'] : null
    }).subscribe(resp => {
      switch (method) {
        case 'participate':
          this.router.navigate(['participate', resp.purchaseId], {
            queryParams: {
              email: this.checkout_form.get('email').value,
              first_name: this.checkout_form.get('first_name').value,
              last_name: this.checkout_form.get('last_name').value,
              cellphone: this.checkout_form.get('cellphone').value,
            }
          });
          break;
        case 'share':
          this.router.navigate(['share', resp.purchaseId]);
          break;
      }
    }, (err: any) => {
      if (err.status === 403) {
        this.dialog.open(DialogErrorComponent, {
          data: {
            message: 'Ha ocurrido un error con los datos ingresados, para mas información contáctanos a ' +
            '<a href="mailto:info@wenjoy.com.co">' +
            '<strong>info@wenjoy.com.co</strong></a>'
          }
        });
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/checkout/checkout.component.ts